module.exports = __webpack_public_path__ + "static/media/missed-penalty.svg.989c45e0.png";